export type RRFilterOption<T> = string | T;
